import React from 'react';
import { Box } from '@mui/material';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      id={`goal-tabpanel-${index}`}
      aria-labelledby={`goal-tab-${index}`}
      style={{ display: value === index ? 'block' : 'none' }}
      {...other}
    >
      <Box>{children}</Box>
    </div>
  );
}

export default TabPanel;

